import { useAuthenticationStore } from "../state/modules/authentication";

export default {
    install(Vue, options) {
        const authStore = useAuthenticationStore();

        Vue.config.globalProperties.$can = function(actions) {
            if (typeof actions === 'string')
                actions = [actions];
            if (typeof actions !== 'object')
                return false;

            // Let's check if the permission is an old permission
            actions = actions.map(action => {
                let parts = action.split('.');

                if (parts[1] && ['create', 'update', 'delete'].includes(parts[1]) && action !== 'jobs.create') {
                    parts[1] = 'manage';
                    action = parts.join('.');
                }

                action = action.replace('*', '(.+)');
                return action;
            })

            const currentUser = authStore.currentUser;
            if (!currentUser) {
                return false;
            }

            const company = currentUser.companies.find(i => i.id === authStore.currentCompany.id);
            if (company && company.pivot && company.pivot.is_owner) {
                return true;
            }

            for (const action of actions) {
                if (authStore.permissions[authStore.currentCompany.id].find(perm => perm.match(`^${action}$`))) {
                    return true;
                }
            }

            return false;
        }
    }

}
